// extracted by mini-css-extract-plugin
export default {"container":"f4iid","statusCell":"DWXEP"};